import { roleActionTypes, userActionTypes } from '../actions/types';
import { roleService } from '../services';
import _ from 'lodash';

const _refreshTokenOnFailure = (error, failureAction, pendingRefreshToken) => {
  if (error.error === 'jwt expired') {
    if (pendingRefreshToken) {
      return {
        type: userActionTypes.PENDING_REFRESH_TOKEN,
        error,
      };
    } else {
      return { type: userActionTypes.INVALID_TOKEN, error };
    }
  } else {
    return { type: failureAction, error };
  }
};

const getAll = () => {
  return (dispatch, getState) => {
    dispatch(request());

    roleService.findAll().then(
      roles => {
        dispatch(success(roles));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            roleActionTypes.FETCH_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: roleActionTypes.FETCH_REQUEST };
  }
  function success(roles) {
    return { type: roleActionTypes.FETCH_SUCCESS, roles };
  }
}

export const roleActions = {
  getAll,
};
